import React, { useState } from "react";
import { Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/SidebarMainAccount.js";
import Header from "components/Navbars/MainAccountNavbar";
import routesMainAccounts from "routes-main-account";
import { AppointmentRoutes } from "views-main-account/AppointmentList";

function MainAccountDashboard(props) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const mainPanel = React.useRef();
  const location = useLocation();

  React.useEffect(() => {
    mainPanel.current.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="wrapper">
      <Sidebar
        {...props}
        routes={routesMainAccounts}
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
      />
      <div className={`main-panel ${isSidebarOpen ? "collaped" : ""}`} ref={mainPanel}>
        <Header {...props} toggleSidebar={toggleSidebar} />
        <Routes>
          {routesMainAccounts.map((prop, key) => {
            return (
              <Route
                path={prop.path}
                element={prop.component}
                key={key}
              />
            );
          })}

          <Route path="/appointments/*" element={<AppointmentRoutes />} />
        </Routes>
        <Footer fluid />
      </div>
      <Outlet />
    </div>
  );
}

export default MainAccountDashboard;
